import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/reducers';
import { LoaderState } from 'store/slices/loader';

export const loaderSelector = createSelector<RootState, LoaderState, LoaderState>(
  state => state.loader,
  loader => loader
);

export const isLoadingSelector = createSelector<RootState, LoaderState, boolean>(
  loaderSelector,
  loader => loader.isLoading || false
);
